module.exports = __webpack_public_path__ + "img/lightning.6ca43eac.svg";